import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { getStyle } from '../../utils/utils';
import CBMediaQuery from './CBMediaQuery';

// Mobile sort control. Replaces clickable table-header sorting on small screens by
// offering every sortable field with both ascending and descending options.
// Props:
//   fields    [{ label, field }] sortable fields (backend ordering names)
//   ordering  current ordering string ('field' = asc, '-field' = desc)
//   onChange  (orderingString) => void
class CBMobileSortSelect extends Component {
  render() {
    const { fields, ordering, onChange, t } = this.props;
    if (!fields || fields.length === 0) {
      return null;
    }
    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'wrap')}>
            <span style={getStyle(screenSize, styles, 'label')}>{t('sortBy', { ns: 'common' })}</span>
            <select
              value={ordering || ''}
              onChange={(e) => onChange(e.target.value)}
              style={getStyle(screenSize, styles, 'select')}
            >
              {fields.map((f) => [
                <option key={f.field + '-asc'} value={f.field}>{f.label} {'↑'}</option>,
                <option key={f.field + '-desc'} value={'-' + f.field}>{f.label} {'↓'}</option>,
              ])}
            </select>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    wrap: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      paddingBottom: 12,
    },
    label: {
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: 13,
      flexShrink: 0,
    },
    select: {
      flex: 1,
      minWidth: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      color: '#FFFFFF',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: 20,
      padding: '8px 12px',
      fontSize: 14,
    },
  },
};

export default translate('common')(CBMobileSortSelect);
